import { useInfiniteQuery } from '@tanstack/react-query'

import { transferServices } from '../transferServices'
import { FetchSavingGoalHistoryAdaptedParams } from '../transferTypes'
import { QUERY_KEYS } from '@/constants/queryKeys'

/**
 * Hook to fetch saving goal history with infinite pagination
 */
export const useGetSavingGoalHistory = (
  params: FetchSavingGoalHistoryAdaptedParams,
) => {
  return useInfiniteQuery({
    initialPageParam: 0,
    queryKey: [QUERY_KEYS.SAVINGS_GOAL_HISTORY, params],
    queryFn: ({ pageParam }) => {
      return transferServices.fetchSavingGoalHistory({
        ...params,
        page_id: pageParam,
      })
    },
    getNextPageParam: (lastPage) => lastPage.next_page_id || undefined,
    select: (data) => {
      return {
        ...data,
        pages: data.pages.flatMap((page) => page.transfers),
      }
    },
    staleTime: 60 * 5 * 1000, // 5 minutes
    enabled: !!params.saving_goal_id,
  })
}
